import { useState } from "react";
import { useNavigate } from "react-router-dom";

const rolePaths = {
  Admin: "/admin",
  Trainer: "/trainer",
  Trainee: "/trainee",
};

const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    try {
      const user = await onLogin(credentials);
      navigate(rolePaths[user.role] || "/");
    } catch (err) {
      setError(err.message || "Invalid credentials. Please try again.");
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <section className="auth-page">
      <div className="auth-illustration">
        <p className="eyebrow">Welcome back</p>
        <h2>Access your dashboard</h2>
        <p className="muted">Track attendance, tasks, and placements in one place.</p>
        <ul className="bullet-list">
          <li>Admins: manage cohorts, trainers, and placements.</li>
          <li>Trainers: assign tasks, monitor progress, and share updates.</li>
          <li>Trainees: log attendance, submit tasks, and apply to roles.</li>
        </ul>
        <div className="hint-card">
          <p className="small muted">Demo credentials</p>
          <p className="small">admin@example.com | password</p>
        </div>
      </div>

      <div className="auth-card">
        <h1>Login</h1>
        <form onSubmit={handleSubmit}>
          <label>
            Email
            <input name="email" type="email" value={credentials.email} onChange={handleChange} required />
          </label>
          <label>
            Password
            <input
              name="password"
              type="password"
              value={credentials.password}
              onChange={handleChange}
              required
            />
          </label>
          {error && <p className="error-callout">{error}</p>}
          <button type="submit" className="primary">
            Login
          </button>
        </form>
      </div>
    </section>
  );
};

export default Login;
